import { useNavigate } from 'react-router-dom'

export function SelectedStationBox({ station }) {
  const navigate = useNavigate()
  if (!station) return null
  return (
    <div className="mx-2 mb-2 mt-2 px-2 py-2 rounded-xl border border-blue-100 bg-blue-50 flex flex-col gap-1 items-center text-center">
      <div className="text-xs font-semibold text-blue-400 uppercase tracking-wide">Vybraná stanice</div>
      <button
        className="text-xs font-mono text-gray-500 bg-gray-100 hover:bg-gray-200 px-1.5 py-0.5 rounded-full border border-gray-300 transition-colors"
        onClick={() => navigate(`/station/${station.gh_id}`)}
      >
        {station.gh_id}
      </button>
      <div className="font-semibold text-sm leading-snug">{station.full_name || station.name}</div>
    </div>
  )
}
